// extracted by mini-css-extract-plugin
export default {"frame":"home_frame__nYc8C"};